module.exports = __webpack_public_path__ + "img/subscribe.1f76ee2c.png";